<template>
    <section class="detail">

        <navigation selected="recap"></navigation>

        <div class="inner">

            <div class="line"></div>

            <div class="gift_cards_header">
                <h1>{{ copydeck.page_recap.title_your_order[lang] }}</h1>
                <p class="warning">{{ copydeck.page_recap.text_warning[lang]}}</p>
            </div>

            <div class="cart_resume">
                <cart-recap></cart-recap>
                <subtotal :orders="orders"></subtotal>
            </div>

            <div class="cart_modify">
                <router-link :to="getRoute('order')" class="cta previous" id="cta_restart">
                    <span>{{ copydeck.page_gift_card.btn_edit_recap[lang] }}</span>
                </router-link>

                <p v-html="copydeck.page_recap.txt_reservations_info[lang]"></p>
            </div>

            <div class="credits_policy">
                <p class="credits_cards">
                    {{ copydeck.page_gift_card.txt_accepted_credit_cards[lang] }}
                    <img src="/images/LS_visa.png" alt="Visa" />
                    <img src="/images/LS_mastercard.png" alt="MasterCard" />
                </p>

                <p>
                    <!--                    <router-link target="_blank" :to="{name: 'Privacy'}">{{ copydeck.page_gift_card.txt_link_confidentiality[lang] }}</router-link>-->
                    <a :href="copydeck.page_gift_card.url_link_confidentiality[lang]" data-hello="world"
                       target="_blank">{{ copydeck.page_gift_card.txt_link_confidentiality[ lang ] }}
                    </a>
                </p>
            </div>

            <form>
                <div class="status-error" v-if="pageError !== ''"> {{ pageError }}</div>
            </form>

            <next-step-button
                :to="getRoute('coords')"
                :can-submit="clickNext"
                :label="copydeck.page_gift_card.btn_next_recap[lang]"></next-step-button>

        </div>

    </section>
</template>

<script>
import NextStepButton from "../components/NextStepButton.vue";
import Subtotal       from "../components/Subtotal.vue";
import CartRecap      from "../components/CartRecap.vue";
import Navigation     from "../components/Navigation.vue";

export default {
    name: "Recap",
    components: {Navigation, CartRecap, Subtotal, NextStepButton},

}
</script>

<script setup>

import {onMounted, ref} from "vue";
import {useMainStore}   from "../stores/main";
import {storeToRefs}  from "pinia";

let store = useMainStore();
let { copydeck, productGroups,  lang, orders, orderCount, hasOrder } = storeToRefs(store);
let { router, getOrderPrice, getRoute } = store;

let pageError = ref("");

function clickNext ()
{
    let bOrder = hasOrder.value;

    const lowestOrder = orders.value.reduce( (a, o) =>
                                             {

                                                 if (o.isDeliveryByMail)
                                                 {
                                                        return a;
                                                 }

                                                 let price = getOrderPrice(o, orders.value);

                                                 return a > price && price > 0 ? price : a;

                                             }, Number.POSITIVE_INFINITY);


    if (!bOrder)
    {
        pageError.value = copydeck.value.page_gift_card.error_no_order[lang.value];
    }

    if (lowestOrder < 25)
    {
        bOrder = false;
        pageError.value = copydeck.value.page_gift_card.error_order_too_low[lang.value];
    }

    return bOrder;


}


onMounted ( () =>
            {

                if (orderCount.value === 0)
                {
                    router.push({name: "Order"})
                }
                else
                {
                    if (parent)
                    {
                        // parent.debouncedResize;
                    }
                }
            })



</script>
